import React from 'react'
import PropTypes from 'prop-types'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Button as BaseButton } from 'antd-mobile'

export default class Button extends React.Component {
  render() {
    const { intl, name = 'submit', size, children, className, ...restProps } = this.props
    var defaultClassName = classes.componentsButton
    if (size) {
      defaultClassName += ` am-button-${size}`
    }
    if (className) {
      defaultClassName += ` ${className}`
    }
    return (
      <BaseButton className={defaultClassName} {...restProps}>
        {children || (
          <b>
            <FormattedMessage {...messages[name]} />
          </b>
        )}
      </BaseButton>
    )
  }
}

Button.propTypes = {
  name: PropTypes.oneOf([
    'collect',
    'downloadPayBy',
    'download',
    'custom',
    'send',
    'take',
    'downloadApp',
    'downloadLower',
    'goToApp'
  ]).isRequired
}
